import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['contract', 'contractsEmpty'];

  print() {
    window.print()
  }

  filterContracts(event) {
    const query = event.target.value.trim().toLowerCase()
    let shown = 0

    this.contractTargets.forEach(row => {
      const match = query === '' || row.dataset.search.includes(query)
      row.classList.toggle('d-none', !match)
      if (match) shown += 1
    })

    if (this.hasContractsEmptyTarget) this.contractsEmptyTarget.classList.toggle('d-none', shown > 0)
  }
}
